// import "../../../static/load"
// import "../../../static/error-logger"
import { useLocation } from "@reach/router"
import { Script } from "gatsby"
import React from "react"
import { Helmet } from "react-helmet"
import LazyLoad from "react-lazyload"
import Footer from "../../components/footer"
import EventFooter from "../Footer/event-footer"
import { Refreshbtn } from "../common/button"
import Favicon from "./../../assets/images/favicon.png"

function Frame(props) {
  const { extraTags, seo } = props
  const currentLocation = useLocation()
  const FooterSection = () => {
    return (
      <footer
        className={`${props.footerClassName} ${props.theme ? props.theme : ""}`}
        style={{ background: `${props.footerBgColor}` }}
      >
        {props.FooterName === "Super-Summit" ? (
          <EventFooter />
        ) : (
          <Footer
            bodyClassName={props.bodyClassName}
            footerClass={props.footerClass}
            newButton={props.newButton}
            theme={props.theme}
            bigFooter={props.bigFooter}
          />
        )}
      </footer>
    )
  }
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{seo?.title || props.title}</title>
        <meta
          name="description"
          content={seo?.description || props.description}
        />
        <meta name="referrer" content="no-referrer-when-downgrade" />
        <meta name="keywords" content={seo?.keywords || props.keywords} />
        <meta property="og:title" content={seo?.title || props.title} />
        <meta
          property="og:description"
          content={seo?.description || props.description}
        />
        {seo?.image?.url && (
          <meta property="og:image" content={seo?.image?.url} />
        )}
        {props?.ogImage?.url && (
          <meta property="og:image" content={props?.ogImage?.url} />
        )}
        <meta
          property="og:type"
          content={seo?.ogType || props.ogType || "website"}
        />
        <link rel="preconnect" href="https://media.graphassets.com" />
        <link rel="preconnect" href="https://us-west-2.graphassets.com" />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href={props.favIcon ? props.favIcon : Favicon}
        />
        <link rel="preconnect" href="https://dev.visualwebsiteoptimizer.com" />
        {/* <script defer src={"/load.js"} /> */}
        {props.hubspotForm && <script src={"/hubspot-form-load.js"} />}
        <body className={props.bodyClassName} />
        {/* body className="ofy-hidden bg-black" for superpod (dark theme)*/}
        {(process.env.SITE_URL === "https://notch.superopsbeta.com/" ||
          process.env.SITE_URL === "https://www.superopsalpha.com/" ||
          currentLocation?.pathname?.startsWith("/lp/")) && (
          <meta name="googlebot" content="noindex"></meta>
        )}
        {extraTags}
      </Helmet>

      {props.hubspotMeeting && (
        <Script src="https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js" />
      )}
      {/* <Script src="https://fast.wistia.com/assets/external/E-v1.js" /> */}
      {process.env.ENABLE_GATSBY_REFRESH_ENDPOINT && <Refreshbtn />}
      <div className={props.className}>
        {props.children}
        {props.IsFooterVisble === "No" ? null : props.lazyLoad ? (
          <LazyLoad>
            <FooterSection />
          </LazyLoad>
        ) : (
          <FooterSection />
        )}
      </div>
    </>
  )
}

export default Frame
